import { render, staticRenderFns } from "./OauthPage.vue?vue&type=template&id=167b44a0&scoped=true"
import script from "./OauthPage.vue?vue&type=script&lang=js"
export * from "./OauthPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b44a0",
  null
  
)

export default component.exports